import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import { mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { get } from "lodash-es";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import PopoverSetGroupDefault from "views/ProjectGroupPage/components/PopoverSetGroupDefault";
import ShareIcon from "@mui/icons-material/Share";
import ColorGroupPickerPopover from "views/ProjectGroupPage/Modals/ColorGroupPickerPopover";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ReactDOMServer from "react-dom/server";
import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import styled from "styled-components";
import { Box } from "@mui/material";
import { useEffect } from "react";
import {
  CustomEventDispose,
  CustomEventListener,
  DELETE_PROJECT_GROUP,
} from "constants/events";
import { apiService } from "constants/axiosInstance";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MenuOutlinedIconCus = () => (
  <MenuOutlinedIcon
    sx={{
      width: "1.3em",
      height: "1.3em",
    }}
    style={{ color: "#787878" }}
  />
);

const StyledMenuOutlinedIcon = styled(MenuOutlinedIconCus)`
  padding: 3px;
  cursor: pointer;
  color: #787878;
  border-radius: 3px;
`;

export const TitleTable = ({
  currentGroup,
  setCurrentGroup,
  typeData,
  expand,
  onExpand = () => {},
  isAllGroup = false,
  doEditProjectGroup,
  handleSelectColor,
  getCurrentGroup,
}) => {
  const { t } = useTranslation();
  const query = useQuery();
  const history = useHistory();
  const groupID = query.get("groupID");
  const isShared = query.get("is-shared");
  const isAllProjects = !!!currentGroup?.name;
  const groupName = isShared
    ? t("LABEL_SHARED_GROUP")
    : get(currentGroup, "name", t("LABEL_WORKING_GROUP"));

  const refSetGroupDefault = useRef(null);

  const _handleOpenSetGroup = (event) => {
    refSetGroupDefault.current._open(event.currentTarget, currentGroup);
  };

  const _renderIconExpand = (event) => {
    return <StyledMenuOutlinedIcon onClick={() => onExpand(!expand)} />;
  };

  const _renderTitleRecently = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }`}
    >
      {_renderIconExpand()}
      <span>{t("LABEL_SEE_RECENTLY")}</span>
    </div>
  );

  const _renderTitlePersonal = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }
  `}
    >
      {_renderIconExpand()}
      <span>{t("LABEL_PERSONAL_BOARD")}</span>
    </div>
  );

  const _renderTitleAllProject = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }`}
      style={{ transform: "translateX(-8px)" }}
    >
      <Box
        sx={{
          "&:hover": {
            background: "#EBEDF0",
          },
        }}
        style={{
          transform: `${expand ? "scale(-1, -1)" : "scale(1, 1)"}`,
          marginRight: 10,
          padding: 5,
          borderRadius: 7,
        }}
        onClick={() => onExpand(!expand)}
        onMouseEnter={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOpenOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
        onMouseLeave={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
      >
        {_renderIconExpand()}
      </Box>

      {!isAllProjects && (
        <ColorGroupPickerPopover
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          handleSelectColor={(colorProps) => {
            console.log(currentGroup);
            setCurrentGroup({
              ...currentGroup,
              color: colorProps?.color,
            });
            handleSelectColor({
              projectGroupId: get(currentGroup, "id"),
              color: colorProps?.color,
            });
          }}
          projectGroup_id={get(currentGroup, "id")}
          projectGroupColor={get(currentGroup, "color")}
        >
          <div
            id="colorGroupPickerPopover__modal_groupicon"
            style={{
              width: 40,
              height: 40,
              background: get(currentGroup, "color"),
              borderRadius: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: 10,
              cursor: "pointer",
            }}
          >
            {/* <img
              src={get(currentGroup, "icon")}
              alt={get(currentGroup, "name")}
              width={35}
              height={35}
            /> */}
            <WorkspacesIcon style={{ color: "white" }} />
          </div>
        </ColorGroupPickerPopover>
      )}
      {isShared && (
        <div
          id="colorGroupPickerPopover__modal_groupicon"
          style={{
            width: 40,
            height: 40,
            background: "#0078F3",
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 10,
            cursor: "pointer",
          }}
        >
          <ShareIcon style={{ color: "white" }} />
        </div>
      )}
      {groupName === t("LABEL_WORKING_GROUP") && (
        <div
          id="colorGroupPickerPopover__modal_groupicon"
          style={{
            width: 40,
            height: 40,
            background: "#0078F3",
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 10,
            cursor: "pointer",
          }}
        >
          {/* <img
              src={get(currentGroup, "icon")}
              alt={get(currentGroup, "name")}
              width={35}
              height={35}
            /> */}
          <WorkspacesIcon style={{ color: "white" }} />
        </div>
      )}
      <div style={{ display: "flex" }}>
        <abbr title={groupName}>{groupName}</abbr>
        {!isAllProjects && (
          <>
            <Box
              className="wp-wrapper-button"
              style={{ marginLeft: 10 }}
              sx={{
                "&:hover": {
                  background: "#0000000f",
                },
              }}
            >
              <KeyboardArrowDownIcon
                sx={{
                  "&:hover": {
                    background: "#rgba(0, 0, 0, 0.1294117647)",
                    fill: "#151b26",
                    cursor: "pointer",
                  },
                  "&:active": {
                    background: "#rgba(0, 0, 0, 0.1294117647)",
                    fill: "#151b26",
                    cursor: "pointer",
                  },
                }}
                onClick={_handleOpenSetGroup}
              />
            </Box>

            <DefaultGroupIcon idGroup={get(currentGroup, "id")} />
          </>
        )}
      </div>
      {!isAllProjects && (
        <PopoverSetGroupDefault
          ref={refSetGroupDefault}
          currentGroup={currentGroup}
          getCurrentGroup={getCurrentGroup}
        />
      )}
    </div>
  );

  function resolveTitle() {
    switch (typeData) {
      case 1:
        return _renderTitleRecently();
      case 2:
        return _renderTitlePersonal();
      default:
        return _renderTitleAllProject();
    }
  }

  return <>{resolveTitle()}</>;
};

const DefaultGroupIcon = ({ idGroup = "" }) => {
  const idGroupDefault = useSelector(
    ({ groupTask }) => groupTask.defaultGroupTask.data || ""
  );
  const idGroupDefaultLocal = localStorage.getItem(
    "WPS_WORKING_SPACE_DEFAULT_ACCESS"
  );

  if (
    idGroupDefault === `?groupID=${idGroup}` ||
    `?groupID=${idGroup}` === idGroupDefaultLocal
  ) {
    return (
      <div className="wp-wrapper-button">
        <FlagOutlinedIcon style={{ color: "#666" }} />
      </div>
    );
  }

  return null;
};
